import React, { useReducer, useEffect, useCallback } from "react";
import { withCookies } from "react-cookie";

import ManagementHeader from "../components/batches/Management/ManagementHeader";
import ManagementFilters from "../components/batches/Management/ManagementFilters";
import ManagementList from "../components/batches/Management/ManagementList";

import BatchCard from "../components/batches/Management/BatchCard/BatchCard";

import ScrollToTop from "../components/ScrollToTop";
import Globals from "../Globals";

import batchService from "../services/BatchesService";

const initialBatchesState = {
  loading: true,
  list: [],
  filteredList: [
    { loading: true },
    { loading: true },
    { loading: true },
    { loading: true },
  ],
  filters: {
    name: "",
    status: {
      1: true, //active
      2: false, //cancelled
      4: false, //bought
      5: true, //pending
      7: false, //pending authorization
    },
  },
};

const batchesReducer = (state, { type, payload }) => {
  switch (type) {
    case "SET_LIST":
      return {
        ...state,
        loading: false,
        list: payload,
        filteredList: payload.filter(
          (batch) =>
            batch?.Name.toLowerCase().includes(
              state.filters.name.toLowerCase()
            ) && state.filters.status[batch.IdStatus]
        ),
      };
    case "SET_FILTERS":
      const noFiltersSelected =
        !payload.name &&
        Object.values(payload.status).every((status) => !status);
      return {
        ...state,
        filters: payload,
        filteredList: noFiltersSelected
          ? state.list
          : state.list.filter(
              (batch) =>
                batch.Name.toLowerCase().includes(payload.name.toLowerCase()) &&
                payload.status[batch.IdStatus]
            ),
      };
    default:
      return state;
  }
};

const BatchesPage = ({ cookies }) => {
  const [state, dispatch] = useReducer(batchesReducer, initialBatchesState);

  const fetchBatches = useCallback(async () => {
    const token = cookies.get(Globals.COOKIES.JWT)?.AccessToken;
    const {
      body: { Result },
    } = await batchService.getBatches({ IdBach: null }, token);

    dispatch({ type: "SET_LIST", payload: Result || [] });
  }, [cookies]);

  useEffect(() => {
    fetchBatches();
  }, [fetchBatches]);

  return (
    <section
      className="o-content-section u-pt-small u-rema-full-height"
      data-testid="batchesPageTestId"
    >
      <ScrollToTop />
      <div className="o-page-wrap o-page-wrap--xsmall">
        <ManagementHeader amount={state.filteredList.length} />
        <ManagementFilters
          filters={state.filters}
          onChange={(payload) => dispatch({ type: "SET_FILTERS", payload })}
        />
        <ManagementList
          list={state.filteredList}
          component={BatchCard}
          valueChanging={state.filters}
          itemKey={"Id"}
          extraClasses={{
            listItemClasses: "u-2/4@m u-pr-large u-pr-none@s",
            listClasses: "",
          }}
        />
      </div>
    </section>
  );
};

export default withCookies(BatchesPage);
